import { defineStore } from "pinia";
import api, { permateConfig } from "~/config/extensionsApi";
import { postApiAxios } from "~/helpers";

export const useOderStore = defineStore("oder", {
  state: () => ({
    paymentUrl: null,
    redirectUrl: null,
    orderInfo: null,
    productsParent: [],
    loading: false,
    error: null,
  }),

  getters: {
    getItemsOrder: (state) => {
      if (!state.orderInfo?.[0]?.items) {
        return [];
      }

      const items = state.orderInfo[0].items;
      return items.map((item) => {
        const parentSku = item.sku.split("-")[0];
        const parentProduct = state.productsParent.find((product) => product.sku === parentSku);
        return {
          ...item,
          productParent: parentProduct || null,
        };
      });
    },
  },

  actions: {
    async createPaymentUrlVnpay(body) {
      this.loading = true;
      this.error = null;

      try {
        const config = {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json; charset=UTF-8",
          },
        };

        const result = await postApiAxios(api.vnpay.vnpay_create_payment, body, config);
        this.paymentUrl = result;
      } catch (err) {
        this.error = err.message || "Failed to fetch order data";
        console.error("Error fetching order:", err);
      } finally {
        this.loading = false;
      }
    },

    async createPaymentUrlShopee(body) {
      this.loading = true;
      this.error = null;

      try {
        const result = await postApiAxios(api.shopeepay.shopeepay_create_payment, body);
        this.redirectUrl = result;
      } catch (err) {
        this.error = err.message || "Failed to fetch order data";
        console.error("Error fetching order:", err);
      } finally {
        this.loading = false;
      }
    },

    async changePayment(incrementId: string, paymentMethod: string) {
      this.loading = true;
      this.error = null;

      try {
        let params = {
          increment_id: incrementId,
          payment_method: paymentMethod,
        };
        const result = await postApiAxios(api.sales.change_payment, params);
        if (result?.code === 200) {
          return result.result;
        } else return null;
      } catch (err) {
        this.error = err.message || "Failed to fetch change payment method";
        console.error("Error fetching change payment method:", err);
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async changeStatusShopeeOrder(orderId: string, amount: string) {
      this.loading = true;
      this.error = null;

      try {
        let params = {
          orderId: orderId,
          amount: amount,
        };
        const result = await postApiAxios(api.shopeepay.shopeepay_trans, params);
        if (result?.code === 200) {
          return result.result;
        } else return null;
      } catch (err) {
        this.error = err.message || "Failed to fetch change payment method";
        console.error("Error fetching change payment method:", err);
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async pushOrderPermate(orderData: {
      external_conversion_id: string;
      sale_value: number;
      offer_id?: string;
      event_id?: string;
    }, pmClickCookie?: string) {
      this.loading = true;
      this.error = null;

      try {
        let pmClickData;
        
        // Handle different cookie formats
        if (typeof pmClickCookie === 'string') {
          try {
            // Try to parse if it's a JSON string
            const decodedCookie = decodeURIComponent(pmClickCookie);
            pmClickData = JSON.parse(decodedCookie);
          } catch (e) {
            return null;
          }
        } else if (typeof pmClickCookie === 'object') {
          // Already parsed object
          pmClickData = pmClickCookie;
        } else {
          return null;
        }

        if (!pmClickData || !pmClickData.click) {
          return null;
        }

        // Check if this order has already been tracked
        const trackingKey = `permate_tracked_${orderData.external_conversion_id}`;
        if (typeof localStorage !== 'undefined') {
          const alreadyTracked = localStorage.getItem(trackingKey);
          if (alreadyTracked) {
            return null;
          }
        }

        const requestBody = {
          api_key: permateConfig.api_key,
          pm_adv_id: permateConfig.pm_adv_id,
          click_uuid: pmClickData.click,
          offer_id: permateConfig.offer_id,
          event_id: orderData.event_id || "",
          sale_value: orderData.sale_value,
          external_conversion_id: orderData.external_conversion_id
        };
        
        const result = await postApiAxios(api.sales.push_order_permate, requestBody);
        
        if (result?.code === 200) {
          // Mark this order as tracked
          if (typeof localStorage !== 'undefined') {
            localStorage.setItem(trackingKey, 'true');
          }
          return result.result;
        } else {
          return null;
        }
      } catch (err) {
        this.error = err.message || "Failed to push order to permate";
      } finally {
        this.loading = false;
      }
    },

  },
});